import React from "react";
import Header from './Header';
import { Link, useNavigate } from "react-router-dom";

const CreateNewMember = () => {
    const token = localStorage.getItem("JWTToken");
    const navigate = useNavigate();

    return (<>
        <Header />
        <div className="min-hight85vh">
            <div className="bg-grey py-3">
                <div className="container">
                    <Link className="fs-18 BackBtn text-dark" to={'/AdminPanel'}>
                        Admin Panel
                    </Link> <span className="fs-18">/ Create new member</span>
                </div>
            </div>
            <div className="container my-5">
                <div className="row nav-tabs border-0">
                    <div className="col-4 shadow p-4 mx-auto">
                        <div className="p-4">
                            <h5 className="TruveyColor fw-bold text-center">Add new member</h5>
                        </div>
                        <div className="mb-5">
                            <div className="mb-4">
                                <label htmlFor="Email" className="nav-link">Email</label>
                                <input type="text" className="Sanket-Control fs-14 p-2 mt-2" />
                            </div>
                            <div>
                                <label htmlFor="Email" className="nav-link">Role</label>
                                <select className="Sanket-Control bg-grey nav-link mt-2 fs-14 Truveytext p-2">
                                    <option value="">Select a role</option>
                                    <option value="">Admin</option>
                                    <option value="">User</option>
                                </select>
                            </div>
                        </div>
                        <div className="text-end pt-5">
                            <button className="me-3 fw-bold btn">Cancel</button>
                            <button className="Gold px-4  border-0 br-5">Add</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </>)
}
export default CreateNewMember;